import { create } from 'zustand';
import { VerifyIfAlreadyStartSimuladaoResponseDto } from '../models/VerifyIfAlreadyStartSimuladaoResponseDto';
import { GetCurrentSimuladaoResponseDto } from '../models/getCurrentSimuladaoResponseDto';

export type SimuladaoTab = 'subscription' | 'countdown';

interface SimuladaoState {
  currentSimuladao: GetCurrentSimuladaoResponseDto | null;
  setCurrentSimuladao: (simuladao: GetCurrentSimuladaoResponseDto) => void;
  openedSimuladaoData: VerifyIfAlreadyStartSimuladaoResponseDto | null;
  setOpenedSimuladaoData: (
    data: VerifyIfAlreadyStartSimuladaoResponseDto
  ) => void;
  currentInstructionsPage: number;
  setCurrentInstructionsPage: (page: number) => void;
}

export const useSimuladaoStore = create<SimuladaoState>((set) => {
  return {
    currentSimuladao: null,
    setCurrentSimuladao: (simuladao: GetCurrentSimuladaoResponseDto) =>
      set({ currentSimuladao: simuladao }),

    openedSimuladaoData: null,
    setOpenedSimuladaoData: (data: VerifyIfAlreadyStartSimuladaoResponseDto) =>
      set({ openedSimuladaoData: data }),
    
    currentInstructionsPage: 0,
    setCurrentInstructionsPage: (page: number) =>
      set({ currentInstructionsPage: page }),
  };
});
